import { Typography, Wrapper } from '@screentone/core';

import { PageModule, UiModuleType } from 'data/generated/graphql';
import styles from './UiModuleFieldsHeader.module.scss';

interface UiModuleHeaderProps {
  pageModule: PageModule;
}

export const UiModuleFieldsHeader = ({ pageModule }: UiModuleHeaderProps) => {
  const { uiModuleType, uiModuleFields } = pageModule;

  if (!uiModuleFields) return null;

  switch (uiModuleType) {
    case UiModuleType.UiBasicModuleType:
      return uiModuleFields.basicModule?.title ? (
        <Wrapper margin={{ bottom: 'xs' }} className={styles.header} data-testid="page-title-name">
          <Typography size="sm" weight="bold" margin={{ right: 'sm' }} color="ink">
            {uiModuleFields.basicModule.title}
          </Typography>
          <Typography variant="note">{uiModuleFields.basicModule.subtitle}</Typography>
        </Wrapper>
      ) : null;
    case UiModuleType.UiBasicOptionalModuleType:
    case UiModuleType.UiFeedsModuleType:
      return null;
    case UiModuleType.UiRankedModuleType:
      return (
        <Wrapper margin={{ bottom: 'xs' }} className={styles.header} data-testid="page-ranked-title-name">
          <Typography size="sm" weight="bold" margin={{ right: 'sm' }}>
            {uiModuleFields.rankedModule?.title}
          </Typography>
        </Wrapper>
      );
    case UiModuleType.UiTitleModuleType:
      return uiModuleFields.titleModule?.title ? (
        <Wrapper margin={{ bottom: 'xs' }} className={styles.header} data-testid="page-title-name">
          <Typography size="sm" weight="bold" margin={{ right: 'sm' }} color="ink">
            {uiModuleFields.titleModule.title}
          </Typography>
          <Typography variant="note">{uiModuleFields.titleModule.subtitle}</Typography>
        </Wrapper>
      ) : null;
    case UiModuleType.UiTitlePinnedModuleType:
      return uiModuleFields.titlePinnedModule?.title ? (
        <Wrapper margin={{ bottom: 'xs' }} className={styles.header} data-testid="page-title-name">
          <Typography size="sm" weight="bold" margin={{ right: 'sm' }}>
            {uiModuleFields.titlePinnedModule.title}
          </Typography>
        </Wrapper>
      ) : null;
    case UiModuleType.UiTextModuleType:
      return uiModuleFields.textModule?.mainText || uiModuleFields.textModule?.secondaryText ? (
        <Wrapper margin={{ bottom: 'xs' }} className={styles.header}>
          <Typography size="sm" weight="bold" margin={{ right: 'sm' }}>
            {uiModuleFields.textModule.mainText}
          </Typography>
          <Typography variant="note" className={styles.truncatedText}>
            {uiModuleFields.textModule.secondaryText}
          </Typography>
        </Wrapper>
      ) : null;
    default:
      return null;
  }
};
